module.exports = __webpack_public_path__ + "static/media/background.e30ed820.png";